export default "__VITE_ASSET__BUFso5Lu__"